import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import { EventManagementAuditTrailContainer } from '../../../../../../models/aggregates/cms/event-calendar';


@Injectable({
  providedIn: 'root'
})
export class EventManagementAuditTrailService extends BaseApiTemplateService<EventManagementAuditTrailContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'events/audit-trails/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'events/audit-trails/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'events/audit-trails/backoffice-ep';
    this.httpClient = http;
  }
}
